import React from "react";
import { Link } from "react-router-dom";
import "../../css/privacy.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) || [];

  return (
    <div className="privacy-page">
      <Header />
      <main className="privacy__main">
        <div className="privacy__inner">
          <nav className="privacy__breadcrumb" aria-label={t("privacy.breadcrumbAria")}>
            <Link to="/" className="privacy__breadcrumb-link">
              {t("privacy.breadcrumb")}
            </Link>
          </nav>

          <h1 className="privacy__title">{t("privacy.title")}</h1>
          <p className="privacy__lastUpdated">{t("privacy.lastUpdated")}</p>
          <p className="privacy__intro">{t("privacy.intro")}</p>

          <div className="privacy__sections">
            {Array.isArray(sections) &&
              sections.map((sec, idx) => (
                <section key={`privacy-sec-${idx}`} className="privacy-sec" aria-labelledby={`privacy-heading-${idx}`}>
                  <h2 id={`privacy-heading-${idx}`} className="privacy-sec__title">
                    {sec.title}
                  </h2>
                  <p className="privacy-sec__text">{sec.body}</p>
                </section>
              ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
